import { render } from "./PdfCustomInputPage.vue?vue&type=template&id=565c02f3&scoped=true&ts=true"
import script from "./PdfCustomInputPage.vue?vue&type=script&lang=ts"
export * from "./PdfCustomInputPage.vue?vue&type=script&lang=ts"

import "./PdfCustomInputPage.vue?vue&type=style&index=0&id=565c02f3&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565c02f3"]])

export default __exports__